import { MutationTree } from 'vuex';


import { ClientStatus, StateType } from './state';

const mutations: MutationTree<StateType> = {
  setStatus(state: StateType, status: ClientStatus) {
    state.status = status;
  },
};

export default mutations;
